import { useCookies } from '@packages/shared/src/providers/CookieProvider/CookieProvider';
import { getEcState } from '@packages/shared/src/utils/ecState/ecState';
import { useSearchParams } from 'next/navigation';
import { getAllAudiences } from '../utils/audiences';
import { createFilterForCurrentAudiences, createFilterForTimeControl } from '../utils/filterResult';

export const useContentFilters = () => {
  const { getCookies } = useCookies();
  const cookies = getCookies();
  const audiences = getAllAudiences(getEcState(cookies));
  const query = Object.fromEntries(useSearchParams()?.entries() ?? []);
  const { TestDate } = query;
  return [createFilterForCurrentAudiences(audiences), createFilterForTimeControl(TestDate)];
};
